

export enum AviatorOnlineUserType {
   aviatorOnlineAdmin='AviatorOnlineAdmin',
   student='student',
   flightSchool='flightschool',
   flightInstructor='flightinstructor',
}

export enum AviatorOnlineUserTypeIds {
    student=1,
    flightSchool=2,
    aviatorOnlineAdmin=3,
    flightInstructor=4,
}

export function convertUserType(userType: AviatorOnlineUserType): number {
    if (!userType) {
        return AviatorOnlineUserTypeIds.student;
    }

    switch (userType.toLowerCase()) {
        case AviatorOnlineUserType.student:
            return AviatorOnlineUserTypeIds.student;
        case AviatorOnlineUserType.flightSchool:
            return AviatorOnlineUserTypeIds.flightSchool;
        case AviatorOnlineUserType.flightInstructor:
            return AviatorOnlineUserTypeIds.flightInstructor;
        case AviatorOnlineUserType.aviatorOnlineAdmin:
            return AviatorOnlineUserTypeIds.aviatorOnlineAdmin;
    }
}

